<template>
  <div  style="position:fixed;top: 0;width: 100%;height: 60px;background-color: white;z-index: 10;">

  <img  id ="burgerburger" src="img/faces/burger.png" style="width:30px;margin-top: 18px;margin-left: 0px;display:block !important;z-index: 10;" @click="kerkessni()">
<h4 id ="societe" style="z-index: 10  !important;margin-top: -30px !important; text-align: left;" > {{ societe }}</h4>
</div>
</template>
<script>

     import $ from 'jquery'
     import {BACKEND_URL} from '../pages/GLOBALS'
  export default {
    name:'TopNavBar',
    computed: {
      routeName () {
        const {name} = this.$route
        return this.capitalizeFirstLetter(name)
      },
      title(){
        return this.$route.name
      }
    },
    data () {
      return {
        societe:'Polytechs',
        activeNotifications: false,
        open:true,
        tableData:'',
        links:[]
      }
    },
      created() {
        $.ajaxSetup({
            data: {
              'sessionId': this.$store.getters.sessionId,
            },
          });
        var self = this
        var request = $.ajax({
            url: BACKEND_URL+"controller/suivi_actions.php",
            async: false,
            type: "POST",
            data: {
              'get_liste_action': 1,
            },
            dataType: "html",
            success: function(data) {
                // console.log(data)
                var dataParsed = JSON.parse(data)
                self.tableData=dataParsed.listeActions

            }
        })
        //---------------------------------------------------------------------------------------
        $.ajax({
            url: BACKEND_URL+"controller/suivi_actions.php",
            async: false,
            type: "POST",
            data: {
              'get_user_societe': 1,
            },
            dataType: "html",
            success: function(html) {
                self.societe=html;
            }
        })
        
      },
    methods: {
      goToAction(NUM_ACTION){
        this.$router.push( {path: '/admin/action', query: { num_act: NUM_ACTION }} )
      },
      kerkessni(){
        if(this.open){
          var links =document.getElementsByClassName('nav-main__links')[0].getElementsByTagName('p');
          //document.getElementsByClassName('logo')[0].style.display = "none";
          document.getElementsByClassName('main-panel')[0].style.width = "calc(100% - 0px)";
          document.getElementsByClassName('sidebar-wrapper')[0].style.width="0px"
          document.getElementsByClassName('sidebar')[0].style.width="0px"
          document.getElementById('burgerburger').style.marginLeft="10px";
          document.getElementById('societe').style.marginLeft="50px";
          
          this.links=[]
          for(var i=0;i<links.length;i++){
            this.links.push(links[i].innerHTML);
            links[i].innerHTML="";
          }
        }
        else{
          var links = document.getElementsByClassName('nav-main__links')[0].getElementsByTagName('p');
          document.getElementsByClassName('logo')[0].style.display = "block";
          document.getElementsByClassName('main-panel')[0].style.width = "calc(100% - 200px)";
          document.getElementsByClassName('sidebar-wrapper')[0].style.width="200px"
          document.getElementsByClassName('sidebar')[0].style.width="200px"
          document.getElementById('burgerburger').style.marginLeft="-190px";
          document.getElementById('societe').style.marginLeft="-150px";

          // Refractored
          /*this.links=[]
          for(var i=0;i<links.length;i++){
            this.links.push(links[i].innerHTML);
            links[i].innerHTML="";
          }*/
          
          for(var i=0;i<links.length;i++){    
            links[i].innerHTML=this.links[i];
          }
        }
        this.open=!this.open;
      },
      capitalizeFirstLetter (string) {
        return string.charAt(0).toUpperCase() + string.slice(1)
      },
      toggleNotificationDropDown () {
        this.activeNotifications = !this.activeNotifications
      },
      closeDropDown () {
        this.activeNotifications = false
      },
      toggleSidebar () {
        this.$sidebar.displaySidebar(!this.$sidebar.showSidebar)
      },
      hideSidebar () {
        this.$sidebar.displaySidebar(false)
      }
    },
     mounted(){
      
       this.kerkessni()
       this.kerkessni()

     }
    
  }

</script>
<style>

</style>
